module.exports = __webpack_public_path__ + "static/media/download.6483548f.svg";